import { useCallback } from 'react';
import { useForm, UseFormReturn } from 'react-hook-form';

import { useExerciseForm } from 'modules/exercises/hooks';

import { FillInTheBlanksExercise } from '../types';
import { FillInTheBlanksExerciseInput, FillInTheBlanksQuestionInput } from '../types/form';
import { transformFillInTheBlanksExerciseToFormInput } from '../utils';

interface FillInTheBlanksExerciseFormHookInput {
  exerciseIndex: number;
  exercise?: FillInTheBlanksExercise;
}

interface FillInTheBlanksExerciseFormHookOutput {
  useFormProps: UseFormReturn<FillInTheBlanksExerciseInput>;

  getNextQuestion: (index: number) => FillInTheBlanksQuestionInput;
}

export default function useFillInTheBlanksExerciseForm(input: FillInTheBlanksExerciseFormHookInput): FillInTheBlanksExerciseFormHookOutput {
  const { exercise, exerciseIndex } = input;
  const { getDefaultExerciseData } = useExerciseForm();

  function getDefaultValues(): FillInTheBlanksExerciseInput {
    if (exercise) {
      const result = transformFillInTheBlanksExerciseToFormInput(exercise);
      return result;
    }

    const coreData = getDefaultExerciseData(exerciseIndex);
    return {
      ...coreData,
      questions: [{ text: '' }],
    };
  }

  const useFormProps = useForm<FillInTheBlanksExerciseInput>({ defaultValues: getDefaultValues() });

  const getNextQuestion = useCallback((index: number): FillInTheBlanksQuestionInput => {
    return {
      text: '',
    };
  }, []);

  return {
    useFormProps,
    getNextQuestion,
  };
}
